var _style, _polyline, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 494.4 547.3",
    style: {
      enableBackground: "new 0 0 494.4 547.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#091520;stroke-width:20;stroke-miterlimit:10;}\n")), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "61.4,76.8 61.4,456.9 432.5,456.9 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 100.1,
    y: 186.1,
    className: "st0",
    width: 49.6,
    height: 230.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 184.9,
    y: 223.5,
    className: "st0",
    width: 49.6,
    height: 192.7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 269.6,
    y: 286.6,
    className: "st0",
    width: 49.6,
    height: 129.7
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 354.4,
    y: 86.2,
    className: "st0",
    width: 49.6,
    height: 330.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/report-icon.bdb356265e567bd6169c0539d8c6026d.svg";
export { ForwardRef as ReactComponent };